<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" *ngIf="slides.length != 0">
    <ng-container  *ngFor="let slide of slides" >
        <div ngxSlickItem *ngIf="myFlag2" class="slide">
            <div class="slider-content desktop home">
                <a (click)="redirectTo(slide)" href='javascript:void(0);'>
                    <img [src]="statePersist.getSafeUrl(slide.web_image_url)" alt="" width="100%">
                </a>
            </div>
        </div>
    </ng-container>

    <ng-container  *ngFor="let slideMobile of slidesMobile">
        <div ngxSlickItem *ngIf="myFlag1" class="slide ">
            <div class="slider-content mobile-setting" >
                <a (click)="redirectTo(slideMobile)" href='javascript:void(0);'>
                    <img [src]="statePersist.getSafeUrl(slideMobile.mob_image_url)" alt="" width="100%">
                </a>
            </div>
        </div>
    </ng-container>
    
    
</ngx-slick-carousel>